import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import USER_TYPES from 'constants/UserTypes';
import DeclineAllComponent from './DeclineAllComponent';
const defaultApproveMessage = 'CONFIRM_APPROVAL_MESSAGE';
const missingDocsApproveMessage = 'CONFIRM_APPROVE_MESSAGE_MISSING_DOCS';
const approveTitle = 'CONFIRM_APPROVAL_TITLE';
const declineTitle = 'CONFIRM_DECLINE_TITLE';
const approveAllMessage = 'CONFIRM_APPROVAL_ALL_MESSAGE';
const AccessorialConfirmModal = ({ show, isBulk, isDecline, confirmType, accessorial, onConfirm, onHide, }) => {
    const { t } = useTranslation();
    const [declineNote, setDeclineNote] = useState('');
    const [declineReasonCode, setDeclineReasonCode] = useState(null);
    const [errors, setErrors] = useState({ declineNote: {} });
    // Reset internal state when modal closes
    useEffect(() => {
        if (!show) {
            setDeclineNote('');
            setDeclineReasonCode(null);
            setErrors({ declineNote: {} });
        }
    }, [show]);
    const handleDeclineNote = useCallback((value) => {
        if (value && value !== '') {
            setErrors((prev) => (Object.assign(Object.assign({}, prev), { declineNote: {} })));
        }
        setDeclineNote(value);
    }, []);
    const handleDeclineReasonCode = useCallback((value) => {
        if (value) {
            setDeclineReasonCode(value);
        }
    }, []);
    const handleConfirm = useCallback(() => {
        onConfirm({ declineNote, declineReasonCode });
    }, [onConfirm, declineNote, declineReasonCode]);
    // Compute primaryDisabled
    let primaryDisabled;
    if (isBulk) {
        primaryDisabled =
            isDecline &&
                accessorial.payee_type === USER_TYPES.CARRIER &&
                !declineReasonCode;
    }
    else if (isDecline) {
        const isNotFilledCorrectly = confirmType === USER_TYPES.CARRIER
            ? (!declineReasonCode &&
                accessorial.payee_type !== USER_TYPES.VENDOR) ||
                !declineNote.trim()
            : !declineNote.trim();
        primaryDisabled = isNotFilledCorrectly;
    }
    else {
        primaryDisabled = false;
    }
    // Determine title
    const title = isDecline ? t(declineTitle) : t(approveTitle);
    // Determine message
    let message;
    if (isDecline) {
        const showReasonCodeDropdown = isBulk
            ? accessorial.payee_type === USER_TYPES.CARRIER
            : confirmType === USER_TYPES.CARRIER &&
                accessorial.payee_type === USER_TYPES.CARRIER;
        message = (React.createElement(DeclineAllComponent, { error: errors.declineNote, value: declineNote, declineReasonCode: declineReasonCode, onNoteChange: handleDeclineNote, onDeclineReasonCodeChange: showReasonCodeDropdown && handleDeclineReasonCode, confirmType: confirmType }));
    }
    else {
        const approveMsg = isBulk
            ? approveAllMessage
            : (accessorial === null || accessorial === void 0 ? void 0 : accessorial.missing_docs) === true
                ? missingDocsApproveMessage
                : defaultApproveMessage;
        message = t(approveMsg);
    }
    return (React.createElement(ConfirmModal, { dataTestId: isBulk ? 'ConfirmModal-67dbe1b4' : 'ConfirmModal-03f9282c', show: show, payableType: accessorial.payableType, title: title, message: message, onHide: onHide, primaryDisabled: primaryDisabled, onConfirm: handleConfirm }));
};
export default AccessorialConfirmModal;
